export const NODE_URL = process.env.REACT_APP_NODE_URL;
